import { Roles } from '@/auth/azure/Roles'
import RouterErrorHandler from '@/components/RouterErrorHandler'
import AnomaliesPage from '@/routes/hours/anomalies/AnomaliesPage'
import { AbsenceAnomaliesPageRoute } from '@/routes/hours/anomalies/absences/AbsenceAnomaliesPage.route'
import { StampingAnomaliesPageRoute } from '@/routes/hours/anomalies/stampings/StampingAnomaliesPage.route'
import { RoleRoute } from '@/types'
import { faWarning } from '@fortawesome/free-solid-svg-icons'
import { redirect } from 'react-router-dom'

export const anomaliesTabs: RoleRoute[] = [
  {
    index: true,
    loader: () => redirect('stampings'),
    visible: false,
    allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
  } satisfies RoleRoute,
  StampingAnomaliesPageRoute,
  AbsenceAnomaliesPageRoute,
]

export const AnomaliesPageRoute: RoleRoute = {
  path: 'anomalies',
  element: <AnomaliesPage />,
  children: anomaliesTabs,
  errorElement: <RouterErrorHandler />,
  allowedRoles: [Roles.GlobalAdministrator, Roles.Administrator],
  handle: {
    crumb: () => ({
      label: 'Anomalie Fluida',
      icon: faWarning,
    }),
  },
}
